module.exports = __webpack_public_path__ + "img/12_29.c82e0d04.png";